import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PostingTimeTooltip from './PostingTimeTooltip';

function MerchantDescriptionDetailed({ merchant, config }) {
  const {
    name, description, disclaimerBreakdown, daysToPostTimeboundText, isDirect,
  } = merchant;

  const { exclusions, limits, specialTerms } = disclaimerBreakdown;
  const { directMerchantName, directMerchantDescription } = config;

  const hasExclusions = !isEmpty(exclusions);
  const hasLimits = !isEmpty(limits);
  const hasSpecialTerms = !isEmpty(specialTerms);

  const formatLimits = (limits = []) => (
    limits
      .map((item) => (item.endsWith('.') ? item : `${item}.`))
      .join(' ')
  );
  const formatTerms = (specialTerms = []) => specialTerms.join(' ');

  const formattedLimits = formatLimits(limits);
  const formattedTerms = formatTerms(specialTerms);

  return (
    <div className="mn_merchantDescriptionDetailed" id="merchantDisclaimer">
      {isDirect &&
        <div className="mn_breakdown">
          <div className="mn_h3">{directMerchantName}</div>
          <p className="mn_merchantDescriptionText">{directMerchantDescription}</p>
        </div>
      }
      {
        hasExclusions &&
        <div className="mn_breakdown">
          <div className="mn_h3">Exclusions</div>
          <ul>{exclusions.map(exclusion => <li key={exclusion}>{exclusion}</li>)}</ul>
        </div>
      }
      {
        hasLimits &&
        <div className="mn_breakdown">
          <div className="mn_h3">Limits</div>
          <p>{formattedLimits}</p>
        </div>
      }
      {
        hasSpecialTerms &&
        <div className="mn_breakdown">
          <div className="mn_h3">Special terms</div>
          <p>{formattedTerms}</p>
        </div>
      }
      { daysToPostTimeboundText &&
        <div className="mn_breakdown">
          <div className="mn_h3">
            <span>Estimated posting time</span>
            <PostingTimeTooltip />
          </div>
          <p>{daysToPostTimeboundText}</p>
        </div>
      }
      <div className="mn_breakdown">
        <div className="mn_h3">About {name}</div>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default MerchantDescriptionDetailed;
